module.exports = __webpack_public_path__ + "static/media/skovdyrkerne_logo.26bf1050.png";